import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AccountService } from 'src/app/services/account.service';
import { ProductService } from 'src/app/services/product.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { OcrErrorModalComponent } from '../ocr-error-modal/ocr-error-modal.component';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import * as moment from 'moment';

@Component({
  selector: 'app-document-upload-modal',
  templateUrl: './document-upload-modal.component.html',
  styleUrls: ['./document-upload-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DocumentUploadModalComponent implements OnInit {
  @Input('data') data: any;
  @Output() subscribeAddon: EventEmitter<any> = new EventEmitter();
  beforeImageUpload = true;
  afterImageUpload = true;
  errorMessage = '';
  showError = false;
  type;
  public ocrScanSuccess: Boolean = false;
  beforeImageObj = {
    file: null,
    url: null,
    imageView: '',
    isPdf: false,
  };
  afterImageObj = {
    file: {},
    url: null,
    imageView: '',
  };
  documentId: any;
  documentExpiryDate: any;
  pdfFile: any;
  frontError = false;
  backError = false;
  loading = false;
  isUserLoggedIn: boolean;
  LoggedIn: boolean;
  userInfo: any;
  currentAccount: any;
  mobileNumber: any;
  sku: any;
  isArabic: any;
  addonCMSUrl: any;
  price: string;
  ismobileScreen: boolean;
  isExpended: Boolean;
  documentName: any;
  agreedOnterms: any;
  allowPayWithLoyaltyPaymentMode: boolean = false;
  isHomeBound: boolean;
  constructor(
    private modalController: ModalController,
    private sharedService: SharedDataService,
    private cdr: ChangeDetectorRef,
    private ACCS: AccountService,
    private SS: SubjectService,
    private PS: ProductService,
    private UTS: UtilitiesService
  ) { }

  ngOnInit(): void {
    this.ismobileScreen = this.UTS.isMobileDevice();
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }
    if (this.data.edit == true) {
      this.editEID();
    }
  }

  editEID() {
    if (this.data.edit == true) {
      this.beforeImageObj.url = this.data.file.front.base64File;
      this.beforeImageObj.file = this.data.file.front;
      this.beforeImageUpload = false;
      if (this.beforeImageObj.file.type == 'application/pdf') {
        this.beforeImageUpload = false;
        this.beforeImageObj.isPdf = true;
      }
      this.afterImageObj.url = this.data.file.back.base64File;
      this.afterImageObj.file = this.data.file.back;
      this.afterImageUpload = false;
      this.documentId = this.data.file.eid;
      this.documentExpiryDate = this.data.file.expiryDate;
      this.ocrScanSuccess = true;
      this.showError = false;
    }
  }
  close() {
    if (this.data.type == 'popUp' && this.ocrScanSuccess) {
      this.modalController.dismiss({
        eid: this.documentId,
        expiryDate: this.documentExpiryDate,
        success: true,
        front: this.beforeImageObj.file,
        back: this.afterImageObj.file,
      });
    } else {
      this.modalController.dismiss({ close: true });
    }
  }
  emitFile(event) {
    this.onFileChanged(event, 'before');
  }
  emitAfterFile(event) {
    this.onFileChanged(event, 'after');
  }
  onFileChanged(event, type) {
    this.frontError = false;
    this.backError = false;
    this.errorMessage = '';
    const files = event;

    if (files.length === 0) return;

    if (files[0].size > 10485760) {
      this.errorMessage = 'File Size can not be greater than 10MB';
      if (type == 'before') {
        this.frontError = true;
      } else if (type == 'after') {
        this.backError = true;
      }
      return;
    }
    const mimeType = files[0].type;
    if (files[0].type == 'application/pdf') {
      this.beforeImageObj.file = files[0];
      this.beforeImageObj.imageView = 'front';
      this.uploadPdf();
    }
    if (mimeType.match(/image\/*/) == null) {
      //  this.message = "Only images are supported.";
      return;
    }
    if (type == 'before') {
      this.beforeImageObj.file = files[0];
      this.beforeImageObj.imageView = 'front';
    } else {
      this.afterImageObj.file = files[0];
      this.afterImageObj.imageView = 'back';
    }
    const reader = new FileReader();
    let imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      if (type == 'before') {
        this.beforeImageObj.url = reader.result;
        this.beforeImageUpload = false;
      } else {
        this.afterImageObj.url = reader.result;
        this.afterImageUpload = false;
      }
    };
  }
  uploadPdf() {
    this.beforeImageUpload = false;
    this.beforeImageObj.isPdf = true;
    this.pdfFile = this.beforeImageObj.file?.base64File;
  }

  scanDocument() {
    this.loading = true;
    let modal = {
      documentType: 'EID',
      imageList: [
        {
          imageBase64: this.beforeImageObj.url.split(',')[1],
          imageView: this.beforeImageObj.imageView,
        },
        {
          imageBase64: this.afterImageObj.url.split(',')[1],
          imageView: this.afterImageObj.imageView,
        },
      ],
    };

    this.frontError = false;
    this.backError = false;
    this.sharedService.convertImageToPDFBase64(modal).subscribe(
      (resOCR:any ) => {
        const documentResponse = resOCR?.pdfBase64;
        const payload = {
          documentType: 'EID',
          imageList: [
            {
              imageBase64: documentResponse,
              imageView: 'back',
            }
          ]
        }
        this.sharedService.readDocument(payload).subscribe(
          (res) => {
            this.showError = false;
            if (res != null) {
              if (res?.documentResponse[0] && res?.documentResponse[0].DOB) {
                const DOB = this.UTS.convertIncommingDateToSysReadableDate(res?.documentResponse[0].DOB);
                const age = moment().diff(DOB, 'years', false);
                if (age <= 17) {
                  this.documentId =
                    res.documentResponse[0] && res.documentResponse[0]?.documentId;
                  this.documentName =
                    res.documentResponse[0] && res.documentResponse[0]?.name;

                  this.documentExpiryDate =
                    res.documentResponse[0] &&
                    res.documentResponse[0].expiryDate &&
                    res.documentResponse[0].expiryDate
                      .split(' ')
                      .slice(0, -2)
                      .join(' ');
                  this.ocrScanSuccess = true;
                  localStorage.setItem('OCR_RESPONSE', JSON.stringify(res.documentResponse[0]));
                }
                else {
                  // error case display error
                  this.showError = true;
                  this.ocrScanSuccess = false;
                  this.frontError = true;
                  this.backError = true;
                  this.delete('front');
                  this.delete('back');
                  this.loading = false;
                  this.errorModal(false);
                }
              }
              else {
                // error case display error
                this.showError = true;
                this.ocrScanSuccess = false;
                this.frontError = true;
                this.backError = true;
                this.delete('front');
                this.delete('back');
                this.loading = false;
                this.errorModal(true);
              }
            }
            this.loading = false;
          },
          (error) => {
            // error case display error
            this.showError = true;
            this.ocrScanSuccess = false;
            this.frontError = true;
            this.backError = true;
            this.delete('front');
            this.delete('back');
            this.loading = false;
            this.errorModal(true);
          }
        );
      });
  }

  handleDrop(event, type) {
    this.type = type;
    event.preventDefault();
    this.handleInputChange(event);
  }
  handleDragEnter() { }
  handleDragLeave() { }
  onDropped($event) { }
  uploadAdditionalDoc() {
    this.modalController.dismiss({
      documentName: 'Document Name',
      uploaded: true,
      index: this.data.index,
      front: this.beforeImageObj.file,
      back: this.afterImageObj.file,
    });
  }
  delete(type) {
    this.showError = false;
    this.ocrScanSuccess = false;
    this.errorMessage = '';

    if (type == 'front') {
      this.beforeImageObj.url = null;
      this.beforeImageObj.file = null;
      this.beforeImageObj.imageView = null;
      this.beforeImageObj.isPdf = false;
      this.beforeImageUpload = true;
    } else if (type == 'back') {
      this.afterImageObj.url = null;
      this.afterImageObj.file = null;
      this.afterImageObj.imageView = null;
      this.afterImageUpload = true;
    }
  }
  handleInputChange(e) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    if (file.size > 10485760) {
      return;
    }

    if (this.type == 'before') {
      this.beforeImageObj.file = file;
      this.beforeImageObj.imageView = 'front';
    } else {
      this.afterImageObj.file = file;
      this.afterImageObj.imageView = 'back';
    }
    var pattern = /image-*/;

    var reader = new FileReader();

    if (file.type.match(pattern) || file.type == 'application/pdf') {
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsDataURL(file);
    }
  }

  _handleReaderLoaded(e) {
    var reader = e.target;

    if (this.type == 'before') {
      this.beforeImageObj.url = reader.result;
      this.beforeImageUpload = false;
      this.beforeImageObj.file['base64File'] = reader.result;
      if (reader.result.includes('pdf')) {
        this.beforeImageObj.imageView = 'front';
        this.beforeImageUpload = false;
        this.beforeImageObj.isPdf = true;
        this.pdfFile = reader.result;
      }
    } else {
      this.afterImageObj.url = reader.result;
      this.afterImageUpload = false;
      this.afterImageObj.file['base64File'] = reader.result;
    }
  }

  getAccount() {
    let userImages = null;
    this.ACCS.getUserInfo().subscribe(
      (res) => {
        if (res && res?.imageBase64String) {
          userImages = res.imageBase64String;
        }
        this.isUserLoggedIn = true;
        this.LoggedIn = true;

        this.userInfo = res;
        this.cdr.detectChanges();
      },
      (e) => {
        this.isUserLoggedIn = false;
        this.LoggedIn = false;
        this.userInfo = null;
      }
    );
  }

  ngAfterContentInit() {
    this.userInfo = this.ACCS.getUInfo();
    if (this.userInfo && this.userInfo.mainServiceAccountNo) {
      this.SS.currentAccount.subscribe((r) => {
        this.currentAccount = r;
        localStorage.setItem('currentAccount', JSON.stringify(this.currentAccount));
        if (r && localStorage.getItem('currentAccount')) {
          const current_user = JSON.parse(localStorage.getItem('currentAccount'));
          this.currentAccount = current_user;
          this.isUserLoggedIn = true;
          this.mobileNumber = this.currentAccount.mobileNumber
            ? this.currentAccount.mobileNumber
            : this.currentAccount.accountNo
              ? this.currentAccount.accountNo
              : '';

          this.LoggedIn = true;

        }
      });
    } else {
      this.SS.account.subscribe((r) => (this.mobileNumber = r));
    }
    this.SS.skuDetails.subscribe((r) => {
      if (r) {
        this.sku = { ...r, ...this.sku };
        if (this.isArabic) {
          this.addonCMSUrl = this.sku?.tAndcAcceptanceAr;
        } else {
          this.addonCMSUrl = this.sku?.tAndcAcceptanceEn;
        }
        this.cdr.detectChanges();
      }
      if (this.sku && this.sku.listPrice) {
        this.getPrice();
      }
    });
  }

  getPrice() {
    this.price = Number(
      this.sku.listPrice && this.parsePrice(this.sku.listPrice) > 0
        ? this.sku.listPrice
        : this.sku.recurringPrice &&
          this.parsePrice(this.sku.recurringPrice) > 0
          ? this.sku.recurringPrice
          : '0'
    ).toFixed(2);
    this.cdr.detectChanges();
  }

  parsePrice(v) {
    if (Number(v)) {
      return Number(v);
    }
    return v;
  }
  errorModal(generalError) {
    this.openBottomSheet(OcrErrorModalComponent, {generalError: generalError});
  }

  async openBottomSheet(component: any, data?: any, classes = 'verification-modal modal-fullscreen') {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      backdropDismiss: false,
      cssClass: classes,
    });
    modal.onDidDismiss().then((x: any) => {

      this.cdr.detectChanges();
    })
    return await modal.present();
  }

  agreeToggleLastExist(e) {
    this.isExpended = !this.isExpended;
    this.cdr.detectChanges();
  }
  gotoSubscribeAddon(e) {
    this.subscribeAddon.emit(e);
  }
}
